export type OnboardingAddressState = {
  street: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
};

export type OnboardingAddressAction =
  | { type: "SET_STREET"; payload: string }
  | { type: "SET_CITY"; payload: string }
  | { type: "SET_STATE"; payload: string }
  | { type: "SET_POSTCODE"; payload: string }
  | { type: "SET_COUNTRY"; payload: string }
  | { type: "SET_ALL"; payload: Partial<OnboardingAddressState> };

export const onboardingAddressInitialState: OnboardingAddressState = {
  street: "",
  city: "",
  state: "",
  postcode: "",
  country: "",
};

export function onboardingAddressReducer(state: OnboardingAddressState, action: OnboardingAddressAction): OnboardingAddressState {
  switch (action.type) {
    case "SET_STREET":
      return { ...state, street: action.payload };
    case "SET_CITY":
      return { ...state, city: action.payload };
    case "SET_STATE":
      return { ...state, state: action.payload };
    case "SET_POSTCODE":
      return { ...state, postcode: action.payload };
    case "SET_COUNTRY":
      return { ...state, country: action.payload };
    case "SET_ALL":
      return { ...state, ...action.payload };
    default:
      console.log(`Error - incorrect action sent ${JSON.stringify(action)} ${JSON.stringify(state)}`);
      return state;
  }
}
